<template>
  <ZLoader v-if="flagLoading" />
  <div class="w-full h-screen relative bg-brand-gradient overflow-hidden" v-else>
    <div class="flex justify-center pt-4">
      <img src="/teopm.png" class="w-[200px] h-[105px] rounded-lg bg-white/95 p-2 shadow-lg" />
    </div>

    <div
      class="max-w-md mx-auto mt-6 p-8 bg-white rounded-xl shadow-lg border-t-4 border-accent-500"
    >
      <div class="text-center mb-6">
        <h1 class="text-2xl font-bold text-brand-900">Login</h1>
      </div>

      <div class="space-y-4">
        <!-- Email -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            v-model="email"
            type="email"
            placeholder="mail@example.com"
            class="block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
            :class="{
              'border-red-400': !isEmailValid(email),
              'border-green-400': isEmailValid(email),
            }"
          />
        </div>

        <!-- Password -->
        <div class="relative">
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Password
          </label>
          <div class="relative">
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="********"
              class="block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
            />
            <button
              type="button"
              @click="toggleShowPassword"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-brand-600 hover:text-brand-700"
            >
              {{ showPassword ? "Hide" : "Show" }}
            </button>
          </div>
        </div>

        <!-- Forgot Password -->
        <!-- <div class="text-xs text-right">
          <span
            class="text-brand-600 cursor-pointer hover:underline"
            @click="forgotPassword"
          >
            Forgot Password?
          </span>
        </div> -->

        <!-- Error Message -->
        <div v-if="flagLogin" class="text-sm text-red-600 text-center">
          Something went wrong, please try again!
        </div>

        <!-- Buttons -->
        <div class="space-y-3 pt-2">
          <button
            @click="submit"
            class="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-accent-gradient hover:brightness-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
          >
            Login
          </button>
          <button
            @click="register"
            class="w-full px-4 py-2 border border-brand-200 rounded-md shadow-sm text-sm font-medium text-brand-700 bg-white hover:bg-brand-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
          >
            Register User
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref } from "vue";
import ZLoader from "./MainLoader.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onMounted } from "vue";

export default {
  components: { ZLoader },
  setup() {
    const store = useStore();
    const router = useRouter();
    const email = ref("");
    const password = ref("");
    const flagLoading = ref(false);
    const flagLogin = ref(false);
    const showPassword = ref(false);

    const isEmailValid = (email) => /\S+@\S+\.\S+/.test(email);

    const submit = async () => {
      const data = {
        email: email.value,
        password: password.value,
      };

      try {
        flagLoading.value = true;
        flagLogin.value = false;
        await store.dispatch("loginUser", data).then((logged) => {
          if (logged.ok) {
            setTimeout(() => {
              flagLoading.value = false;
              router.push({ name: "RFI Dashboard" });
            }, "3000");
          } else {
            flagLogin.value = true;
            flagLoading.value = false;
          }
        });
      } catch (error) {
        console.error("Error during login:", error);
        flagLogin.value = true;
        flagLoading.value = false;
      }
    };

    const toggleShowPassword = () => {
      showPassword.value = !showPassword.value;
    };
    function register() {
      router.push({ name: "RegisterUser" });
    }

    function forgotPassword() {
      router.push({ name: "RecoverPassword" });
    }

    function goToRegister() {
      router.push({ name: "RegisterUser" });
    }

    onMounted(() => {});

    return {
      email,
      password,
      isEmailValid,
      submit,
      flagLoading,
      forgotPassword,
      goToRegister,
      flagLogin,
      register,
      toggleShowPassword,
      showPassword,
    };
  },
};
</script>

<style scoped>
</style>